import { render, staticRenderFns } from "./ChecklistItemA.vue?vue&type=template&id=2c8e90f0"
import script from "./ChecklistItemA.vue?vue&type=script&lang=js"
export * from "./ChecklistItemA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports